<template>
  <div class="refer-friend-view default-page">
    <img
      :src="bannerImage"
      alt="referring-friend"
      class="default-page__banner mb-5"
    />
    <h1>Акція «Приведи друга»</h1>
    <div class="default-page-section">
      Підключіть друга – отримайте бонуси!<br class="d-block d-md-none" />
      💰 По 3500 бонусів Вам і другу
    </div>
    <div class="default-page-section">
      <ul>
        <li>
          <span>1️⃣</span> Залиште заявку на підключення друга через спеціальну
          форму нижче
        </li>
        <li>
          <span>2️⃣</span> Отримайте бонуси на рахунок після повної абонплати
          друга
        </li>
      </ul>
    </div>
    <div class="default-page-section mb-0">
      <app-phone-input
        v-model="form.phoneYours"
        placeholder="Ваш номер телефону"
        :error="v$.phoneYours.$error ? v$.phoneYours.$errors[0].$message : ''"
        @input="v$.phoneYours.$touch()"
        @focus="handleInputState($event, true)"
        @blur="
          v$.phoneYours.$touch();
          handleInputState($event, false);
        "
      />
      <app-phone-input
        v-model="form.phoneFriends"
        placeholder="Телефон друга"
        :error="
          v$.phoneFriends.$error ? v$.phoneFriends.$errors[0].$message : ''
        "
        @input="v$.phoneFriends.$touch()"
        @focus="handleInputState($event, true)"
        @blur="
          v$.phoneFriends.$touch();
          handleInputState($event, false);
        "
      />
      <app-btn
        class="btn btn-primary w-100"
        :disabled="v$.$invalid || isLoading"
        @click="submitForm"
      >
        <span v-if="!isLoading">Підключити друга</span>
        <span
          v-else
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
      </app-btn>
      <div
        v-show="isShowAdditionalSpace"
        ref="additionalSpace"
        class="additional-space"
      ></div>
    </div>
  </div>
</template>

<script>
import AppBtn from "@/components/common/ui/AppBtn.vue";
import AppPhoneInput from "@/components/common/ui/AppPhoneInput.vue";
import { reactive, ref, computed, nextTick } from "vue";
import useVuelidate from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";
import bannerImage from "@/assets/refer-friend/banner-invite-friend.jpg";
import CrmConnector from "utelecomim-crmconnector";
import { useRouter } from "vue-router";
import useVibration from "@/composition/UseVibration";
import { useStore } from "vuex";

export default {
  name: "ReferFriendView",
  components: {
    AppBtn,
    AppPhoneInput,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const { vibrate } = useVibration();
    const isShowAdditionalSpace = ref(false);
    const activeInputElement = ref(null);
    const additionalSpace = ref(null);

    const form = reactive({
      phoneYours: "",
      phoneFriends: "",
    });

    const rules = {
      phoneYours: {
        required: helpers.withMessage("Це поле обовʼязкове", required),
        valid: helpers.withMessage(
          "Невірний формат номера",
          helpers.regex(/^\+38\s\(\d{3}\)\s\d{3}-\d{2}-\d{2}$/)
        ),
      },
      phoneFriends: {
        required: helpers.withMessage("Це поле обовʼязкове", required),
        valid: helpers.withMessage(
          "Невірний формат номера",
          helpers.regex(/^\+38\s\(\d{3}\)\s\d{3}-\d{2}-\d{2}$/)
        ),
      },
    };

    const v$ = useVuelidate(rules, form);
    const isLoading = ref(false);
    const descriptionText = computed(() => {
      return (
        "Абонент з номером - " +
        form.phoneYours.replace(/\D/g, "") +
        " хоче підключити друга - " +
        form.phoneFriends.replace(/\D/g, "")
      );
    });

    const isMobilePlatform = computed(() => store.getters.isMobilePlatform);

    const handleInputState = (event, value) => {
      if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) return;
      if (value) {
        // focus
        activeInputElement.value = event.target;

        if (!isMobilePlatform.value) return;

        isShowAdditionalSpace.value = true;

        nextTick(() => {
          const inputRect = event?.target?.getBoundingClientRect?.();
          const spaceEl = additionalSpace.value;
          const spaceRect = spaceEl?.getBoundingClientRect?.();

          if (inputRect && spaceRect) {
            const distance =
              window.innerHeight - spaceRect.top + inputRect.top - 40;

            spaceEl.style.height = `${distance}px`;
          }

          nextTick(() => {
            window.scrollTo({
              top: document.body.scrollHeight,
              behavior: "smooth",
            });
          });
        });
      } else {
        // blur
        setTimeout(() => {
          // Якщо активний елемент не змінився на новий input — ховаємо
          if (event.target === activeInputElement.value) {
            isShowAdditionalSpace.value = false;
            activeInputElement.value = null;
          }
        }, 300);
      }
    };

    const submitForm = async () => {
      v$.value.$touch();
      if (v$.value.$invalid) return;

      isLoading.value = true;

      const connector = new CrmConnector("https://imapi.prosto.net", {
        timeout: 10000,
        headers: {},
      });

      try {
        const { code, message } = await connector
          .setTitle("Підключення Друга")
          .setDescription(descriptionText.value)
          .setPhone(form.phoneFriends.replace(/\D/g, ""))
          .setUserName("-")
          .setUtmSource("tgminiapp")
          .setTrademarkId(2)
          .send();
        console.log("code", code, "message", message);
        vibrate([50, 200, 100, 200, 200]);
        router.push({ name: "request-success" });
      } catch ({ code, message }) {
        console.log("code", code, "message", message);
        router.push({ name: "request-error" });
      } finally {
        form.phoneYours = "";
        form.phoneFriends = "";
        v$.value.$reset();
        isLoading.value = false;
      }
    };

    return {
      bannerImage,
      form,
      v$,
      isLoading,
      additionalSpace,
      isShowAdditionalSpace,
      isMobilePlatform,
      handleInputState,
      submitForm,
    };
  },
};
</script>

<style scoped lang="less">
@import "@/styles/_mixins.less";

.refer-friend-view {
  .default-page-section {
    .default-ul-list();
  }
}
</style>
